import _Object$keys from 'babel-runtime/core-js/object/keys';

var NAMESPACE = 'td';

var ContextMenu = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.visible, expression: "visible" }], staticClass: "td-context-menu", class: { 'is-left': _vm.isRightOverflow }, staticStyle: { "position": "fixed" }, style: { left: _vm.computedPosition.x + 'px', top: _vm.computedPosition.y + 'px' }, attrs: { "tabindex": "0" } }, [_c('ul', { staticClass: "td-context-menu__main" }, _vm._l(_vm.menu, function (item, index) {
      return _c('td-context-menu-item', { key: index, attrs: { "item": item, "active": _vm.activeIndex === index }, nativeOn: { "mouseenter": function mouseenter($event) {
            _vm.activeIndex = index;
          }, "mouseleave": function mouseleave($event) {
            _vm.activeIndex = -1;
          } } });
    }), 1)]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-context-menu',
  props: {
    menu: Array,
    visible: Boolean,
    containerBounding: [Object],
    position: {
      type: Object
    }
  },
  provide: function provide() {
    return {
      root: this
    };
  },
  data: function data() {
    return {
      x: null,
      y: null,
      activeIndex: -1,
      isBottomOverflow: false,
      computedPosition: {
        x: 0,
        y: 0
      },
      shortcutCollection: [],
      menuLevel: 1,
      isRightOverflow: false
    };
  },
  mounted: function mounted() {
    this.collectShortcut(this.menu, 1);
    document.addEventListener('keydown', this.handleKeyPress);
    // document.addEventListener('mousedown', this.hide)
    // document.addEventListener('mousewheel', this.hide)
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyPress);
    // document.removeEventListener('mousedown', this.hide)
    // document.removeEventListener('mousewheel', this.hide)
  },

  watch: {
    position: function position() {
      var _this = this;

      if (this.visible) {
        this.isRightOverflow = false;
        this.$el.focus();
        this.computedPosition = {
          x: this.position.x,
          y: this.position.y
        };
        this.$nextTick(function () {
          var rect = _this.$el.getBoundingClientRect();

          if (rect.bottom > _this.containerBounding.bottom) {
            _this.computedPosition.y = rect.top - rect.height;
          }
          if (rect.right > _this.containerBounding.right) {
            _this.computedPosition.x = rect.left - rect.width;
          }
        });
      }
    }
  },
  methods: {
    collectShortcut: function collectShortcut(menu, level) {
      for (var i = 0; i < menu.length; i++) {
        menu[i].__level = level;
        if (menu[i].shortcut) {
          this.shortcutCollection.push(menu[i]);
        }
        if (menu[i].children) {
          this.collectShortcut(menu[i].children, level + 1);
        }
      }
    },
    show: function show(e) {
      e.preventDefault();

      this.$emit('show');
    },
    handleKeyPress: function handleKeyPress(e) {
      var _this2 = this;

      if (this.visible) {
        this.shortcutCollection.forEach(function (item) {
          // 如果有tipImage，  tip不会出现所以相对应的快捷键直接关闭
          if (item.tipImage) {
            if (item.shortcut && process.env.NODE_ENV === 'development') {
              console.warn('`item.tipImage` 和 `item.shortcut` 不能共存');
            }
            return;
          }
          if (_Object$keys(item.shortcut).every(function (key) {
            if (key === 'key') {
              return e[key].toLowerCase() === item.shortcut[key].toLowerCase();
            } else {
              return e[key] === item.shortcut[key];
            }
          })) {
            if (_this2.menuLevel >= item.__level) {
              _this2.$emit('click', item);
            }
          }
        });
      }
    },
    click: function click(item) {
      if (!item.disabled) {
        this.hide();
        this.$emit('click', item);
      }
    }
  }
};

var ContextMenuItem = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('li', { staticClass: "td-context-menu__item", class: { 'is-separate': _vm.item.underline } }, [_c('div', { staticClass: "td-context-menu__content", class: { 'is-active': _vm.active }, style: { width: _vm.item.width || '100px' }, on: { "click": _vm.handleClickItem } }, [_vm.item.iconClass || _vm.item.checked ? _c('span', { staticClass: "td-icon", class: [_vm.item.iconClass, _vm.item.checked && 'td-icon-choose'] }) : _vm._e(), _vm._v(" "), _vm.item.text ? _c('span', { staticClass: "td-context-menu__text" }, [_vm._v(_vm._s(_vm.item.text))]) : _vm._e(), _vm._v(" "), _c('span', { staticClass: "td-context-menu__tips" }, [_vm.item.tipImage ? _c('img', { attrs: { "src": _vm.item.tipImage } }) : _vm.item.tip ? [_vm._v(" " + _vm._s(_vm.item.tip) + " ")] : _vm._e()], 2), _vm._v(" "), _vm.item.children ? _c('i', { staticClass: "td-icon-more-right" }) : _vm._e()]), _vm._v(" "), _vm.showChildren ? _c('ul', { ref: "menuChildren", staticClass: "td-context-menu__children", class: { 'is-top': _vm.isBottomOverflow } }, _vm._l(_vm.item.children, function (child, index) {
      return _c('td-context-menu-item', { key: index, attrs: { "item": child, "active": _vm.activeIndex === index }, nativeOn: { "mouseenter": function mouseenter($event) {
            _vm.activeIndex = index;
          }, "mouseleave": function mouseleave($event) {
            _vm.activeIndex = -1;
          } } });
    }), 1) : _vm._e()]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-context-menu-item',
  props: {
    item: {
      type: Object
    },
    active: {
      type: Boolean
    }
  },
  inject: ['root'],
  data: function data() {
    return {
      activeIndex: -1,
      isBottomOverflow: false
    };
  },

  computed: {
    showChildren: function showChildren() {
      return this.item.children && this.item.children.length && this.active;
    }
  },
  methods: {
    handleClickItem: function handleClickItem() {
      this.root.$emit('click', this.item);
    }
  },
  watch: {
    showChildren: function showChildren(newVal) {
      var _this = this;

      if (this.active) {
        this.root.menuLevel++;
      } else {
        this.root.menuLevel--;
      }
      if (newVal) {
        this.$nextTick(function () {
          var rect = _this.$refs['menuChildren'].getBoundingClientRect();

          if (rect.bottom > _this.root.containerBounding.bottom) {
            _this.isBottomOverflow = true;
          }
          if (rect.right > _this.root.containerBounding.right) {
            _this.root.isRightOverflow = true;
          }
        });
      } else {
        // this.root.isRightOverflow = false
        this.isBottomOverflow = false;
      }
    }
  }
};

ContextMenu.install = function (Vue) {
  Vue.component(ContextMenu.name, ContextMenu);
  Vue.component(ContextMenuItem.name, ContextMenuItem);
};

export default ContextMenu;
